<template>
  <div
    v-if="Array.isArray(listEmployee)"
    id="msDisplayEmployee"
  >
    <div
      v-for="(item, index) in listEmployee"
      :key="index"
      class="ms-display-employee w-100 flex items-center justify-between"
      :class="{'disabled' : !isDisplayBtnDelete, 'cursor-default': !isDisplayBtnDelete}"
    >
      <div
        class="flex w-100 display-employee-item"
      >
        <div
          class="d-flex w-100 item-employee" 
        >
          <img
            :src="item.AvatarSource"
            class="employee-avatar"
          >
          <div
            class="infomation-employee"
            :class="{'cursor-default': !isDisplayBtnDelete}"
          >
            <div
              class="flex wrap-text"
              :title="[item.FullName + ' (' + item.Email + ')']"
            >
              <div class="e-name bold m-b-4 m-r-4">
                {{ item.FullName }}
              </div>
              <div class="m-b-4 wrap-text">
                {{ " (" + item.Email + ")" }}
              </div>
            </div>
            <DisplayEmployeeDetail
              :employee="getEmployeeDetailParam(item)"
            />
          </div>
          <div
            v-if="isDisplayBtnDelete"
            class="icon-delete-custom m-r-10"
            @click="deleteItemSelected(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<!-- dvquang2 hiển thị thông tin người được chọn dạng trải phẳng
---- Created: 06/09/2021 -->

<script>
import AvatarService from "@/apis/base/avatar/AvatarService.js";
import DisplayEmployeeDetail from "./DisplayEmployeeDetail.vue";
export default {
  name: "MsDisplayEmployee",
  components: {
    DisplayEmployeeDetail,
  },
  props: {
    // list nhân viên đầu vào
    listEmployee: {
      type: Array,
      default: () => [],
    },
    // show btn Xóa hay không
    isDisplayBtnDelete: {
      type: [Boolean],
      default: true,
    },
    // show onscroll hay không
    showScroll: {
      type: [Boolean],
      default: false,
    },
  },
  data() {
    return {
      //listEmployee: [],
    };
  },
  watch: {},
  created() {
    this.handleDisplaySelectedItem(this.listEmployee);
  },
  mounted() {
    // nếu mà muốn scroll thì addClass này
    if (this.showScroll) {
      $("#msDisplayEmployee").addClass("ms-display-employee-container");
    }
  },
  methods: {
    handleDisplaySelectedItem(listDataRes) {
      const me = this;

      listDataRes.forEach((element) => {
        element.AvatarSource = AvatarService.getAvatar(element.MISAID);
      });
    },

    /**
     * click vào xóa thì emit ra list nhân viên mới sau xóa
     * dvquang2 14/09/2021
     */
    deleteItemSelected(item) {
      const listNotContaintItem = this.listEmployee.filter(
        (x) => x.UserID != item.UserID
      );
      this.$emit("deleteItem", listNotContaintItem);
    },

    /**
     * THNhat 15/03/2022
     */
    getEmployeeDetailParam(employee) {
      return {
        JobTitleName: employee.JobTitleName,
        OrganizationUnitName: employee.OrganizationUnitName,
        OrganizationName: employee.OrganizationName,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.ms-display-employee-container {
  overflow: auto;
  max-height: 290px;
}
.ms-display-employee {
  cursor: pointer;
  padding: 4px 0px;
  border-radius: 4px;
  &:hover {
    background-color: #dbf4ff;
  }
}
.disabled {
  &:hover {
    background-color: white !important;
  }
}
.infomation-employee {
  cursor: pointer;
  width: calc(100% - 52px);
}
.employee-avatar {
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 12px;
}
.employee-infor {
  width: 330px;
}
.display-property {
  width: 80px;
}
.color-6767 {
  color: #616767;
}
.display-employee-item {
  height: auto;
  padding-left: 6px;
}
.item-employee {
  align-items: center;
}
.limit-text-130px {
  max-width: 130px;
}
.cursor-default {
  cursor: default !important;
}
</style>